import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { QA_SECTION_KEY } from '../../../../constants/qa'
import { getQaSelector } from '../../../../utils/common'
import { preventDefault } from '../../../../utils/events'
import { TableControlIcon } from '../../TableControlIcon'

import { QA_NAME_TABLE_VIEW_REGIME_SECTION } from './TableViewRegimeControl.constants'
import {
  getTableViewRegimeNextArrowOption,
  getTableViewRegimeOptions,
} from './TableViewRegimeControl.utils'

import * as styles from './TableViewRegimeControl.module.css'

function TableViewRegimeControl({
  hasBoard,
  hasCalendar,
  hasSplit,
  listViewType,
  onChange,
}) {
  const { t } = useTranslation()

  const containerRef = useRef(null)

  const options = getTableViewRegimeOptions({
    hasBoard,
    hasCalendar,
    hasSplit,
    listViewType,
  })

  function getHandleClickOption(value) {
    return () => {
      if (value !== listViewType) {
        onChange(value)
      }
    }
  }

  function handleKeyDown(event) {
    const nextOption = getTableViewRegimeNextArrowOption({
      container: containerRef.current,
      key: event.key,
      target: event.currentTarget,
    })

    if (nextOption) {
      preventDefault(event)

      nextOption.focus()
    }
  }

  const qaProps = getQaSelector(
    { value: QA_NAME_TABLE_VIEW_REGIME_SECTION },
    QA_SECTION_KEY
  )

  return (
    <div
      {...qaProps}
      className={styles.TableViewRegimeControl}
      ref={containerRef}
    >
      {options.map(option => (
        <TableControlIcon
          Icon={option.Icon}
          className={classNames({ [styles.active]: option.isActive })}
          key={option.name}
          qaName={option.name}
          tooltip={t(option.label)}
          onClick={getHandleClickOption(option.value)}
          onKeyDown={handleKeyDown}
        />
      ))}
    </div>
  )
}

export default TableViewRegimeControl
